<div class="content-container table-comp mb-3">
    <div class="title">
        <mwp-text-translate text="Qualifying Proof of Coverage required to satisfy Opt Out requirements" jsonKey="waiveDocumentsNote" />
    </div>
    <div class="content">
        <div class="p-3">
            <div [innerHTML]="checkoutWaiveDocument.waiveBenefitHTMLDisclaimer | pipeSafeHTML"></div>
        </div>
        <hr class="m-0">
        <div class="px-3">
            <mwp-file-upload (filesEmit)="updateFiles($event)" [isModal]="false" />
        </div>
    </div>
</div>
<div>
    <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="!isValid" (emitComplete)="complete()" />
</div>